export default __webpack_public_path__ + "static/media/A26.2b608e94.png";